<template>
  <!-- Основной контейнер страницы -->
  <MainLayout>
    <!-- Блок выбора роли заказчика -->
    <div class="select-buyer-role">
      <div
        :class="['role-yourself', { 'selected-role': !isDrop }]"
        @click="selectRole(false)"
      >
        СЕБЕ
      </div>
      <div
        :class="['role-drop', { 'selected-role': isDrop }]"
        @click="selectRole(true)"
      >
        ДРОП
      </div>
    </div>

    <!-- Форма для дроповой роли -->
    <DropPageForm
      :payment-amount="dropPrice"
      :selected-size="selectedSize"
      :product-name="productName"
      :product-photo="productPhoto"
      :batch-id="batchId"
      v-if="isDrop"
    />

    <!-- Форма для роли "СЕБЕ" -->
    <PayComponent
      :payment-amount="retailPrice"
      :selected-size="selectedSize"
      :product-name="productName"
      :product-photo="productPhoto"
      :batch-id="batchId"
      v-else
    />

  </MainLayout>
</template>

<script>
import MainLayout from '../components/MainLayout.vue';
import DropPageForm from '../components/DropPageForm.vue';
import PayComponent from '../components/PayComponent.vue';

export default {
  components: {
    MainLayout,
    DropPageForm,
    PayComponent
  },

  data() {
    return {
      isDrop: true, // Булева переменная для выбора роли
    };
  },

  props: {
    dropPrice: {
      type: Number,
      required: true
    },
    retailPrice: {
      type: Number,
      required: true
    },
    selectedSize: {
      type: String,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    productPhoto: {
      type: String,
      required: true,
    },
    batchId: {
      type: [Number, String],
      default: null,
    },
  },
  methods: {
    selectRole(drop) {
        this.isDrop = drop;
    },
  },
};
</script>

<style scoped>
.select-buyer-role {
  display: grid;
  grid-template-columns: 1fr 1fr;
  color: white;
  font-size: 20px;
  text-align: center;
  padding: 2vw;
  background-color: rgba(255, 255, 255, 0.1);
  width: 45vw;
  height: 12vw;
  border-radius: 20px;
  cursor: pointer;
  margin-bottom: 8vw;
}

.selected-role {
  background-color: #32cd32;
  border-radius: 20px;
}
</style>
